import { IconCardWidgetComponent } from './IconCardWidgetComponent';

export function IconCardWidgetComponentC(
  props: React.ComponentProps<typeof IconCardWidgetComponent>,
) {
  return <IconCardWidgetComponent {...props} />;
}
